import omit from 'lodash/omit';

import MediaLibraryState from './media_library_nav_state.js';
import { get as getLocalStorageStore } from 'zoomforth_zf/appglobals/localstorage.js';


const MEDIA_LIBRARY_NAV_STATE_KEY = 'navstate';

// Attributes which should never be stored in localStorage
const NEVER_STORE_ATTRS_NAMES = [
  'text_search',
  'media_types_search'
];


const MediaLibraryStateWithLocalStorage = MediaLibraryState.extend({

  constructor(inputAttrs, opts) {
    
    const storedAttrs = omit(
      getLocalStorageStore().get(MEDIA_LIBRARY_NAV_STATE_KEY, null),
      // Before Jan 2019 we allowed the saving of all attrs in localstorage 
      // so we must also be sure to omit them when reading from localstorage too
      NEVER_STORE_ATTRS_NAMES
    );

    const defaultAttrs = {
      media_types_search: [],
      text_search: '',
      sort_by: 'date_modified:desc',
      folder_id: null,
      asset_display_type: 'list'
    };

    const attrs = { 
      ...defaultAttrs,
      ...storedAttrs, // Stored state attrs always override default attrs
      ...inputAttrs // input state attrs always override everything else
    };
    MediaLibraryState.call(this, attrs, opts);

  },

  set(attrs={}, opts) {
    MediaLibraryState.prototype.set.call(this, attrs, opts);
    getLocalStorageStore().set(
      // Never write certain attrs into localstorage
      MEDIA_LIBRARY_NAV_STATE_KEY, 
      omit(this.toJSON(), NEVER_STORE_ATTRS_NAMES)
    );
  }

});

export default MediaLibraryStateWithLocalStorage;
